/**
 * companyActions — read-only thunks for company identity.
 *
 * After the company-model decommission refactor, the ERP no longer mutates
 * company records. Identity / billing / address are managed on the website
 * backend. The two reads below proxy through the ERP's `/companies/:id`
 * endpoints which themselves delegate to the cached website API.
 *
 * Tenant-local profile (logo, footer, default notes, ZATCA, etc.) lives in
 * `companyProfileActions.js`.
 *
 * Subdomain → companyId resolution is unchanged.
 */

import * as api from "../api/index";

import {
  FETCH_COMPANY,
  FETCH_COMPANY_PUBLIC_DETAILS,
  SET_RESOLVED_COMPANY,
} from "./constants";

export const resolveCompanySubdomain = (subdomain) => async (dispatch) => {
  const CACHE_KEY = `companyCache_${subdomain}`;
  try {
    const { data } = await api.resolveSubdomain(subdomain);
    dispatch({ type: SET_RESOLVED_COMPANY, payload: data });
    // Persist under both the subdomain-specific key and the legacy key
    localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    localStorage.setItem("resolvedCompany", JSON.stringify(data));
    return data;
  } catch (error) {
    // Network error (service unreachable) — fall back to cached entry
    if (!error.response) {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        try {
          const data = JSON.parse(cached);
          dispatch({ type: SET_RESOLVED_COMPANY, payload: data });
          return data;
        } catch {}
      }
    }
    // Real error (4xx) or no cache — propagate
    dispatch({ type: SET_RESOLVED_COMPANY, payload: null });
    throw error;
  }
};

export const getCompany = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchCompany(id);
    dispatch({ type: FETCH_COMPANY, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getCompanyPublicDetails = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchCompanyPublicDetails(id);
    dispatch({ type: FETCH_COMPANY_PUBLIC_DETAILS, payload: data });
  } catch (error) {
    console.log(error);
  }
};
